/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One saved version of a plugin mapping, including its config
 * @export
 * @interface PluginMappingChangeConfigResponse
 */
export interface PluginMappingChangeConfigResponse {
    /**
     * 
     * @type {Date}
     * @memberof PluginMappingChangeConfigResponse
     */
    createdAt: Date;
    /**
     * The earlier version this one was restored from, if it was created by a restore
     * @type {string}
     * @memberof PluginMappingChangeConfigResponse
     */
    restoredFromId: string | null;
    /**
     * Back office user id that saved this version; null if not known
     * @type {string}
     * @memberof PluginMappingChangeConfigResponse
     */
    changedBy: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PluginMappingChangeConfigResponse
     */
    id: string;
    /**
     * Construct a type with a set of properties K of type T
     * @type {{ [key: string]: any; }}
     * @memberof PluginMappingChangeConfigResponse
     */
    config: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingChangeConfigResponse
     */
    pluginId: string;
}

/**
 * Check if a given object implements the PluginMappingChangeConfigResponse interface.
 */
export function instanceOfPluginMappingChangeConfigResponse(value: object): value is PluginMappingChangeConfigResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('restoredFromId' in value) || value['restoredFromId'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('pluginId' in value) || value['pluginId'] === undefined) return false;
    return true;
}

export function PluginMappingChangeConfigResponseFromJSON(json: any): PluginMappingChangeConfigResponse {
    return PluginMappingChangeConfigResponseFromJSONTyped(json, false);
}

export function PluginMappingChangeConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginMappingChangeConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'restoredFromId': json['restoredFromId'],
        'changedBy': json['changedBy'],
        'id': json['id'],
        'config': json['config'],
        'pluginId': json['pluginId'],
    };
}

export function PluginMappingChangeConfigResponseToJSON(value?: PluginMappingChangeConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'restoredFromId': value['restoredFromId'],
        'changedBy': value['changedBy'],
        'id': value['id'],
        'config': value['config'],
        'pluginId': value['pluginId'],
    };
}

